export default function (http) {
    return {
        queryByPage(data) {
            return http.json({
                url: `/aftersale/order/base/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/aftersale/order/base/get?id=${data.id}`,
                data
            })
        },

        getPickInfo(data) {
            return http.json({
                url: `/order/base/getPickAndRepFixInfo?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/aftersale/order/base/save`,
                data
            })
        },

        delete(data) {
            return http.json({
                url: `/aftersale/order/base/delete`,
                data
            })
        },

        terminate(data) {
            return http.json({
                url: `/aftersale/order/base/terminate`,
                data
            });
        },

        queryAfterOrderByRate(data) {
            return http.json({
                url: `/aftersale/order/base/queryAfterOrderByRate?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        match(data) {
            return http.json({
                url: `/picker/admin/match`,
                data
            })
        },


        pass(data) {
            return http.json({
                url: `/aftersale/order/base/pass`,
                data
            })
        },
        fail(data) {
            return http.json({
                url: `/aftersale/order/base/fail`,
                data
            })
        },

        orderReturn(data) {
            return http.json({
                url: `electronic/returnElectronicOrder`,
                data
            })
        },

        orderFinish(data) {
            return http.json({
                url: `electronic/finishElectronicOrder`,
                data
            })
        },
        failElectronicOrder(data) {
            return http.json({
                url: `electronic/failElectronicOrder`,
                data
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/saleorder.js